import { CaretDown, CaretRight } from "@phosphor-icons/react";
import { type ReactNode, useState } from "react";

interface Props {
	name: string;
	defaultCollapsed: boolean;
	fieldCount?: number;
	children: ReactNode;
}

export function FieldGroup({ name, defaultCollapsed, fieldCount, children }: Props) {
	const [collapsed, setCollapsed] = useState(defaultCollapsed);
	return (
		<div className="mb-3">
			<button
				type="button"
				onClick={() => setCollapsed((c) => !c)}
				className="flex w-full items-center gap-1.5 py-1"
			>
				<span className="text-text-muted">
					{collapsed ? <CaretRight size={12} /> : <CaretDown size={12} />}
				</span>
				<span className="text-xs font-semibold uppercase tracking-widest text-text-primary">
					{name}
				</span>
				{fieldCount !== undefined && (
					<span className="text-xs text-text-muted">({fieldCount} fields)</span>
				)}
				<span className="flex-1 border-b border-border" />
			</button>
			{!collapsed && <div className="pl-3 pt-2">{children}</div>}
		</div>
	);
}
